// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AssetRefOut } from './assetRefOut.zod.ts';

export const matchedAssetsOutShapeDefault = `matched`;

export const MatchedAssetsOut = zod.object({
  "cited": zod.array(AssetRefOut),
  "match_run_id": zod.union([zod.uuid(),zod.null()]),
  "partial": zod.boolean(),
  "screened": zod.int(),
  "shape": zod.literal("matched").default(matchedAssetsOutShapeDefault),
  "shortlisted": zod.array(AssetRefOut),
  "status": zod.enum(['complete', 'partial', 'no_match', 'over_budget', 'failed'])
});

export type MatchedAssetsOut = zod.input<typeof MatchedAssetsOut>;
export type MatchedAssetsOutOutput = zod.output<typeof MatchedAssetsOut>;
